import { string, shape } from 'prop-types';

const GameFragment = {
  id: string.isRequired,
  title: string.isRequired,
  short_descr: string.isRequired,
  min_age: string.isRequired,
  min_players: string.isRequired,
};

export let GameType = shape(GameFragment);

export let GameDetailType = shape({
  long_descr: string.isRequired,
  categories: string.isRequired,
  needs: string,
  ...GameFragment,
});



// WEBPACK FOOTER //
// components/types/index.js